import { Link } from "react-router-dom";
import type { CustomerAddress } from "../../../types/customers";
import type { GroupCustomer } from "../../../types/customerGroups";

function formatShippingAddress(addr?: CustomerAddress | null): string {
  if (!addr || typeof addr !== "object") return "—";
  const parts = [
    addr.line1,
    addr.line2,
    [addr.city, addr.province].filter(Boolean).join(", "),
    addr.postal_code,
    addr.country_code,
  ].filter(Boolean);
  return parts.length ? parts.join(", ") : "—";
}

export default function CustomerGroupCustomersTable(props: { customers: GroupCustomer[] }) {
  const { customers } = props;

  return (
    <div className="overflow-hidden card-custom">
      <div className="p-4">
        <p className="text-md font-semibold">Customers in group</p>
      </div>
      <table className="min-w-full divide-y divide-gray-300">
        <thead className="bg-white">
          <tr>
            <th
              scope="col"
              className="py-3 pl-3 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
            >
              Name
            </th>
            <th
              scope="col"
              className="py-3 pl-3 pr-3 text-left text-sm font-semibold text-gray-900"
            >
              Shipping address
            </th>
            <th scope="col" className="relative py-3.5 pl-3 pr-4 text-right sm:pr-6">
              Actions
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200 bg-white">
          {!customers?.length ? (
            <tr>
              <td
                colSpan={3}
                className="py-6 pl-4 pr-3 text-sm text-start sm:pl-6"
                style={{ color: "var(--nav-text-secondary)" }}
              >
                No customers yet, assign some from Customer Details...
              </td>
            </tr>
          ) : (
            customers.map((customer) => (
              <tr key={customer.id}>
                <td className="whitespace-nowrap py-3 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                  {customer.company_name}
                </td>
                <td
                  className="py-3 pl-3 pr-3 text-sm max-w-xs"
                  style={{ color: "var(--nav-text-secondary)" }}
                >
                  {formatShippingAddress(customer.shipping_address)}
                </td>
                <td className="relative whitespace-nowrap py-3 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                  <Link
                    to={`/customers/${customer.id}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center px-3 py-2 text-sm font-semibold text-white rounded-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-[var(--nav-active-accent)] hover:opacity-90 bg-[var(--nav-active-accent)]"
                  >
                    View
                  </Link>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
